import {
  callIfFn,
  EntityPlacerBuilder,
  plannerHistoryHelper
} from "src/components/Planner/planner/history";
import { PlannerAction } from "src/components/Planner/planner/history/planner-action";
import {
  getDeviceById,
  getGroupOfDevice,
  getSerialById,
  getSerialOfDeviceId,
  isDevMergedWithSerials,
  uDev
} from "src/components/Planner/planner/uDev";
import {
  chainChangeDevices,
  getProductOfDevice,
  modDevNote,
  removeTheseDevs,
  sendDevNoteAuto,
  uDevDOM
} from "src/components/Planner/planner/uDev-dom";
import $ from "jquery";
import {ts} from "src/utils/translate"
import {
  hideRotateAndDeviceTools,
  PUTDevData,
  rotateD3Dev,
  saveCurrDevicePos,
  unHighlight,
  updateSimilars
} from "src/components/Planner/planner/planner";
import { PlannerGlobals } from "src/components/Planner/planner/planner-globals";
import {
  ajaxSetSerialProps,
  connectSerials,
  detachFromSerial,
  mergeSerials,
  placeSerialDevices,
  removeSerialDevices
} from "src/components/Planner/planner/serialConnections-dom";
import {
  placeDevice,
  PlaceDeviceBuilder,
  redrawDevice,
  redrawDevices,
  removeDevice
} from "src/components/Planner/planner/deviceDrawing";
import {recalcSwitchPNIDs} from "src/components/Planner/planner/grouping";
import {deepCopy} from "src/components/Planner/controller";
import {
  addMeasurementAjax,
  filterInvalidMeasurements
} from "src/components/Planner/planner/measurement";
/**
 * @typedef {Object} RemovedDevParams
 * @property {Device} device
 * @property {Group[]} groups
 * @property {Note?} note
 * @property {MeasurementConnection[]} removedMeasures
 * @property {Serial?} serial
 * @property {SerialConnection?} serialConnection
 * @property {boolean} wasLastOfSerial
 */

/* DEVICE START */
export class CreateSingleDeviceAction extends PlannerAction {
  /**
   *
   * @param {Device} device
   * @param {boolean} alone
   * @param {Serial | null} targetSerial
   * @param {Serial | null} connectTo
   */
  constructor(device, alone, targetSerial, newAddonDev, connectTo) {
    super();
    this.device = deepCopy(device);
    this.alone = alone;
    this.serialId = targetSerial && targetSerial.id;
    this.connectToId = connectTo && connectTo.id;
    this.newAddonDev = newAddonDev;
    this.newAddonDevSerialId = null;
    this.newAddonDevGroupId = null;
    if (newAddonDev) {
      const addonSerial = getSerialOfDeviceId(newAddonDev.deviceId);
      if (addonSerial) {
        this.newAddonDevSerialId = addonSerial.id;
      }
      const addonGrp = getGroupOfDevice(newAddonDev.deviceId);
      if (addonGrp) {
        this.newAddonDevGroupId = addonGrp.id;
      }
    }

    this.actionName = ts("p_do_action_dev_new", "Placing device");

    this.treeDev = getProductOfDevice(this.device);
    if (!this.treeDev) {
      throw new Error("Device wasn't found in tree, couldn't create history entry.", this.device);
    }
    this.treeDev = Object.assign({}, this.treeDev);
    if (this.device.noteTxt) {
      this.treeDev.note_message = this.device.noteTxt;
    }
    else {
      this.treeDev.prevent_note = true;
    }

    if (!this.serialId && this.treeDev.serializable) {
      var ser = getSerialOfDeviceId(this.device.deviceId);
      if (ser) {
        this.serialId = ser.id;
      }
    }
  }
  execute(callback) {
    var thisVar = this;
    var cloneDev = deepCopy(this.device);
    var preSerId = this.serialId;
    var preDevId = cloneDev.deviceId;
    var preAddonDevId = this.newAddonDev && this.newAddonDev.deviceId;
    const tarSer = getSerialById(this.serialId);

    placeDevice(cloneDev.x, cloneDev.y, cloneDev.roomId, this.treeDev, function (newDev, resp, devSerial, newAddonDev) {
      if (newDev) {
        thisVar.device = deepCopy(newDev);
        if (devSerial) {
          thisVar.serialId = devSerial.id;
        }

        if (preSerId && devSerial) {
          PlannerGlobals.plannerHistoryManager.serialIdChanged(preSerId, devSerial.id);
        }

        if (preDevId) {
          PlannerGlobals.plannerHistoryManager.deviceIdChanged(preDevId, newDev.deviceId);
        }

        if (newAddonDev) {
          if (preAddonDevId) {
            PlannerGlobals.plannerHistoryManager.deviceIdChanged(preAddonDevId, newAddonDev.deviceId);
          }

          if (thisVar.newAddonDevSerialId) {
            const newAddonSerial = getSerialOfDeviceId(newAddonDev.deviceId);
            if (newAddonDev) {
              PlannerGlobals.plannerHistoryManager.serialIdChanged(thisVar.newAddonDevSerialId, newAddonSerial.id);
            }
          }
        }

        const prom = devSerial && thisVar.connectToId ? connectSerials(devSerial.id, thisVar.connectToId) : Promise.resolve();

        prom
        .then(() => {
          redrawDevices();
          callIfFn(callback, true);
        })
        .catch(() => {
          callIfFn(callback, false);
        })
      }
      else {
        callIfFn(callback, false);
      }
    }, this.alone, tarSer, cloneDev.angle, true, undefined, true, true);
  }
  undo(callback) {
    const thisVar = this;
    removeDevice(null, this.device.deviceId)
    .done(function () {
      if (thisVar.newAddonDev) {
        removeDevice(null, thisVar.newAddonDev.deviceId)
        .done(function () {
          redrawDevices();
          callIfFn(callback, true);
        })
        .fail(function () {
          callIfFn(callback, false);
        })
      }
      else {
        redrawDevices();
        callIfFn(callback, true);
      }
    })
    .fail(function () {
      callIfFn(callback, false);
    });
  }
  serialIdChanged(from, to) {
    if (this.serialId && this.equalAsString(this.serialId, from)) {
      this.serialId = to;
    }
    if (this.connectToId && this.equalAsString(this.connectToId, from)) {
      this.connectToId = to;
    }
    if (this.newAddonDevSerialId && this.equalAsString(this.newAddonDevSerialId, from)) {
      this.newAddonDevSerialId = to;
    }
  }
  deviceIdChanged(from, to) {
    if (this.equalAsString(this.device.deviceId, from)) {
      this.device.deviceId = to;
    }
    if (this.newAddonDev && this.equalAsString(this.newAddonDev.deviceId, from)) {
      this.newAddonDev.deviceId = to;
    }
  }
  roomIdChanged(from, to) {
    if (this.equalAsString(this.device.roomId, from)) {
      this.device.roomId = to;
    }
  }
}

export class MoveDeviceAction extends PlannerAction {
  /**
   *
   * @param {number} deviceId
   * @param {Point} fromPt
   * @param {Point} toPt
   * @param {number} fromRoomId
   * @param {number} toRoomId
   * @param {number} fromAngle
   * @param {number} toAngle
   * @param {MeasurementConnection[]} removedMeasures
   * @param {Device[]} similars
   */
  constructor(deviceId, fromPt, toPt, fromRoomId, toRoomId, fromAngle, toAngle, removedMeasures, similars) {
    super();
    this.actionName = ts("p_do_action_dev_move", "Moving device");
    this.deviceId = deviceId;
    this.fromPt = fromPt;
    this.toPt = toPt;
    this.fromRoomId = fromRoomId;
    this.toRoomId = toRoomId;
    this.fromAngle = fromAngle;
    this.toAngle = toAngle;
    this.removedMeasures = removedMeasures;
    this.similars = similars;
  }
  execute(callback) {
    this.do("execute", callback);
  }
  undo(callback) {
    this.do("undo", callback);
  }
  /**
   *
   * @param {"undo" | "execute"} type
   * @param {*} callback
   */
  do(type, callback) {
    var pt, roomId, angle;
    if (type == "execute") {
      pt = this.toPt;
      roomId = this.toRoomId;
      angle = this.toAngle;
    }
    else {
      pt = this.fromPt;
      roomId = this.fromRoomId;
      angle = this.fromAngle;
    }
    var thisVar = this;
    var dev = getDeviceById(this.deviceId);
    var isSingleMerged = !dev.serializable && isDevMergedWithSerials(dev.product_name_id) && thisVar.fromRoomId !== thisVar.toRoomId;
    if (isSingleMerged) {
      var devs = [dev].concat(this.similars).map(function (dev) { return dev.deviceId }).map(getDeviceById);
      devs.forEach(function (dev) {
        dev.roomId = roomId;
        dev.angle = angle;
        dev.x = pt.x;
        dev.y = pt.y;
      });
      var newD = {
        id: null,
        angle: angle,
        x: pt.x,
        y: pt.y,
        roomId: roomId,
        devices: devs
      }
      redrawDevices();
      updateSimilars(newD, [newD])
      .done(function () {
        if (type === "undo") {
          plannerHistoryHelper.putBackMeasurementConns(thisVar.removedMeasures)
          .done(function () {
            callIfFn(callback, true);
          })
          .fail(function () {
            callIfFn(callback, false);
          });
        }
        else {
          filterInvalidMeasurements();
          callIfFn(callback, true);
        }
      })
      .fail(function () {
        callIfFn(callback, false);
      });
    }
    else {
      var d3Data = uDevDOM.getDeviceD3Group(this.deviceId);
      if (!d3Data) { return callIfFn(callback, false); }
      saveCurrDevicePos(d3Data);
      this.writeDevData(d3Data, pt, roomId, angle);
      redrawDevice(d3Data.devices[0].deviceId);
      PUTDevData(d3Data, true, function () {
        redrawDevice(d3Data.devices[0].deviceId);
        if (type === "undo") {
          plannerHistoryHelper.putBackMeasurementConns(thisVar.removedMeasures)
          .done(function () {
            callIfFn(callback, true);
          })
          .fail(function () {
            callIfFn(callback, false);
          });
        }
        else {
          filterInvalidMeasurements();
          callIfFn(callback, true);
        }
      }, function () {
        callIfFn(callback, false);
      });
    }
  }
  /**
   *
   * @param {D3Device} d3Data
   * @param {Point} pt
   * @param {number} roomId
   * @param {number} angle
   */
  writeDevData(d3Data, pt, roomId, angle) {
    d3Data.x = pt.x;
    d3Data.y = pt.y;
    d3Data.roomId = roomId;
    d3Data.angle = angle;
    if (d3Data.id) {
      const serial = getSerialById(d3Data.id);
      if (serial) {
        serial.x = d3Data.x;
        serial.y = d3Data.y;
        serial.roomId = d3Data.roomId;
        serial.angle = d3Data.angle;
      }
    }
    else if (d3Data.connId) {
      d3Data.serials.forEach(x => {
        const serial = getSerialById(x.id);
        if (serial) {
          serial.x = d3Data.x;
          serial.y = d3Data.y;
          serial.roomId = d3Data.roomId;
          serial.angle = d3Data.angle;
        }
      });
    }
    d3Data.devices.forEach(function (dev) {
      const realDev = getDeviceById(dev.deviceId);
      realDev.x = d3Data.x;
      realDev.y = d3Data.y;
      realDev.roomId = d3Data.roomId;
      realDev.angle = d3Data.angle;
    });
  }
  deviceIdChanged(from, to) {
    var thisVar = this;
    if (this.equalAsString(this.deviceId, from)) {
      this.deviceId = to;
    }
    this.similars.forEach(function (dev) {
      if (thisVar.equalAsString(dev.deviceId, from)) {
        dev.deviceId = to;
      }
    });
    plannerHistoryHelper.updateMeasurementDeviceIds(from, to, this.removedMeasures);
  }
  serialIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementSerialIds(from, to, this.removedMeasures);
  }
  wallIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallIds(from, to, this.removedMeasures);
  }
  wallModIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallModIds(from, to, this.removedMeasures);
  }
  roomIdChanged(from, to) {
    if (this.equalAsString(this.fromRoomId, from)) {
      this.fromRoomId = to;
    }
    if (this.equalAsString(this.toRoomId, from)) {
      this.toRoomId = to;
    }
    let thisVar = this;
    this.similars.forEach(function (dev) {
      if (thisVar.equalAsString(dev.roomId, from)) {
        dev.roomId = to;
      }
    });
  }
}

export class RotateDeviceAction extends PlannerAction {
  /**
   *
   * @param {D3Device} d
   * @param {number} fromAngle
   * @param {number} toAngle
   */
  constructor(deviceId, fromAngle, toAngle) {
    super();
    this.actionName = ts("p_do_action_dev_rot", "Rotating device");
    this.deviceId = deviceId;
    this.fromAngle = fromAngle;
    this.toAngle = toAngle;
  }
  execute(callback) {
    var d3Data = uDevDOM.getDeviceD3Group(this.deviceId);
    if (!d3Data) { return callIfFn(callback, false); }
    saveCurrDevicePos(d3Data);
    rotateD3Dev(d3Data, this.toAngle, function () {
      redrawDevice(d3Data.devices[0].deviceId);
      callIfFn(callback, true);
    }, function () {
      callIfFn(callback, false);
    });
  }
  undo(callback) {
    var d3Data = uDevDOM.getDeviceD3Group(this.deviceId);
    if (!d3Data) { return callIfFn(callback, false); }
    rotateD3Dev(d3Data, this.fromAngle, function () {
      redrawDevice(d3Data.devices[0].deviceId);
      callIfFn(callback, true);
    }, function () {
      callIfFn(callback, false);
    });
  }
  deviceIdChanged(from, to) {
    if (this.equalAsString(this.deviceId, from)) {
      this.deviceId = to;
    }
  }
}

export class DeleteSingleDeviceAction extends PlannerAction {
  /**
   *
   * @param {RemovedDevParams} removedDevParams
   */
  constructor(removedDevParams, preventPuts = false) {
    super();
    this.actionName = ts("p_do_action_dev_del", "Deleting device");
    removedDevParams = deepCopy(removedDevParams);
    this.device = removedDevParams.device;
    this.groups = removedDevParams.groups;
    this.note = removedDevParams.note;
    this.serialId = removedDevParams.serial && removedDevParams.serial.id;
    this.serialParams = removedDevParams.serial ? { height: removedDevParams.serial.height, direction: removedDevParams.serial.direction } : null;
    this.serialConnection = removedDevParams.serialConnection;
    this.wasLastOfSerial = removedDevParams.wasLastOfSerial;
    this.removedMeasures = removedDevParams.removedMeasures || [];
    this.preventPuts = preventPuts;
    this.allowDisplacement = !preventPuts;

    this.treeDev = getProductOfDevice(this.device);
    if (!this.treeDev) {
      throw new Error("Device wasn't found in tree, couldn't create history entry.", this.device);
    }

    this.treeDev = Object.assign({}, this.treeDev);
    if (!this.note) {
      this.treeDev.prevent_note = true;
    }

    if (!this.serialId && this.treeDev.serializable && !removedDevParams.preventSerial) {
      var ser = getSerialOfDeviceId(this.device.deviceId);
      if (ser) {
        this.serialId = ser.id;
      }
    }
  }
  execute(callback) {
    var thisVar = this;
    removeDevice(null, this.device.deviceId)
    .done(function () {
      if (!thisVar.preventPuts) {
        redrawDevices();
      }
      recalcSwitchPNIDs();
      callIfFn(callback, true);
    })
    .fail(function () {
      callIfFn(callback, false);
    });
  }
  undo(callback) {
    var thisVar = this;
    var cloneDevice = deepCopy(this.device);
    var preSerId = this.serialId;
    var preDevId = cloneDevice.deviceId;
    new PlaceDeviceBuilder()
    .setPoint(cloneDevice)
    .setAngle(cloneDevice.angle)
    .setRoomId(cloneDevice.roomId)
    .setProduct(this.treeDev)
    .setAlone(this.wasLastOfSerial || !this.device.serializable)
    .setTargetSerial(this.wasLastOfSerial ? null : getSerialById(this.serialId))
    .setPlacedByWizard(true)
    .setForceSerialDisplacement(this.allowDisplacement)
    .setOverrideSerialParams(this.serialParams)
    .setCallback(function (newDev, resp, targetSerial) {
      if (newDev) {
        thisVar.device = deepCopy(newDev);
        if (targetSerial) {
          thisVar.serialId = targetSerial.id;
        }

        if (preSerId && targetSerial) {
          PlannerGlobals.plannerHistoryManager.serialIdChanged(preSerId, targetSerial.id);
        }

        if (preDevId) {
          PlannerGlobals.plannerHistoryManager.deviceIdChanged(preDevId, newDev.deviceId);
          thisVar.deviceIdChanged(preDevId, newDev.deviceId);
        }

        var noteDef = $.Deferred();
        if (thisVar.note) {
          var preNoteId = thisVar.note.note_id;

          function noteCb(dev) {
            if (dev) {
              PlannerGlobals.plannerHistoryManager.noteIdChanged(preNoteId, dev.noteId);
              noteDef.resolve();
            }
            else {
              noteDef.reject();
            }
          }
          if (newDev.noteId) {
            newDev.noteColor = thisVar.note.color;
            newDev.noteTxt = thisVar.note.text;
            if (!thisVar.preventPuts) {
              redrawDevice(newDev.deviceId);
            }
            modDevNote(newDev, thisVar.note.color, thisVar.note.text, noteCb);
          }
          else {
            sendDevNoteAuto(newDev.deviceId, thisVar.note.text, thisVar.note.color, noteCb);
          }
        }
        else {
          noteDef.resolve();
        }

        var groupDef = $.Deferred();
        plannerHistoryHelper.placeDevIntoAllGroups(newDev.deviceId, thisVar.groups, 0, function (res) {
          if (res) { groupDef.resolve(); }
          else { groupDef.reject(); }
        });

        var measureDef = $.Deferred();

        if (thisVar.removedMeasures) {
          var measDefs = [];

          thisVar.removedMeasures.forEach(function (meas) {
            let measDef = $.Deferred();
            measDefs.push(measDef);
            meas.sentToServerPromise = $.Deferred();
            meas.justAdded = true;
            meas.justDeleted = false;
            PlannerGlobals.measurements.push(meas);
            let oriId = meas.id;
            addMeasurementAjax(meas, function (meas) {
              PlannerGlobals.plannerHistoryManager.measurementIdChanged(oriId, meas.id);
              measDef.resolve();
            }, function () {
              measDef.reject();
            });
          });

          $.when.apply($, measDefs)
          .done(function () {
            measureDef.resolve();
          })
          .fail(function () {
            measureDef.reject();
          });
        }
        else {
          measureDef.resolve();
        }

        var serConnDef = $.Deferred();
        if (thisVar.serialConnection) {
          plannerHistoryHelper.setOlderSerialAsTargetInConnection(thisVar.serialConnection);
          plannerHistoryHelper.applySerialConnections([thisVar.serialConnection])
          .then(() => serConnDef.resolve())
          .catch(() => serConnDef.reject());
        }
        else {
          serConnDef.resolve();
        }

        $.when(noteDef, groupDef, measureDef, serConnDef)
        .done(function () {
          if (!thisVar.preventPuts) {
            redrawDevices();
          }
          recalcSwitchPNIDs();
          callIfFn(callback, true);
        })
        .fail(function () {
          callIfFn(callback, false);
        });
      }
      else {
        callIfFn(callback, false);
      }
    })
    .run();
  }
  serialIdChanged(from, to) {
    if (this.serialId && this.equalAsString(this.serialId, from)) {
      this.serialId = to;
    }
    plannerHistoryHelper.updateMeasurementSerialIds(from, to, this.removedMeasures);
    if (this.serialConnection) {
      plannerHistoryHelper.updateSerialIdInConnections(from, to, [this.serialConnection]);
    }
  }
  serialConnectionIdChanged(from, to) {
    if (this.serialConnection) {
      plannerHistoryHelper.updateSerialConnectionId(from, to, [this.serialConnection]);
    }
  }
  deviceIdChanged(from, to) {
    var thisVar = this;
    if (this.equalAsString(this.device.deviceId, from)) {
      this.device.deviceId = to;
    }
    this.groups.forEach(function (grp) {
      grp.deviceIds.forEach(function (dId, idx) {
        if (thisVar.equalAsString(dId, from)) {
          grp.deviceIds[idx] = to;
        }
      });
    });
    plannerHistoryHelper.updateMeasurementDeviceIds(from, to, this.removedMeasures);
  }
  wallModIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallModIds(from, to, this.removedMeasures);
  }
  wallIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallIds(from, to, this.removedMeasures);
  }
  measurementIdChanged(from, to) {
    var thisVar = this;
    this.removedMeasures.forEach(function (meas) {
      if (thisVar.equalAsString(meas.id, from)) {
        meas.id = to;
      }
    });
  }
  roomIdChanged(from, to) {
    if (this.equalAsString(from, this.device.roomId)) {
      this.device.roomId = to;
    }
  }
  noteIdChanged(from, to) {
    if (this.note && this.equalAsString(from, this.note.note_id)) {
      this.note.note_id = to;
    }
  }
}

export class DeleteMultipleDevicesAction extends PlannerAction {
  /**
   *
   * @param {Device[]} removedDevices
   * @param {Group[]} affectedGroups
   * @param {MeasurementConnection[]} removedMeasurements
   * @param {SerialConnection[]} serialConnections
   */
  constructor(removedDevices, affectedGroups, removedMeasurements, serialConnections) {
    super();
    this.actionName = ts("p_do_action_devs_del", "Deleting devices");
    this.removedDevices = removedDevices;
    this.affectedGroups = affectedGroups;
    this.removedMeasurements = removedMeasurements;
    this.removedProduct = getProductOfDevice(this.removedDevices[0]);
    this.serialConnections = serialConnections || [];
  }
  execute(callback) {
    removeTheseDevs(this.removedDevices, res => callIfFn(callback, !!res));
  }
  undo(callback) {
    var thisVar = this;
    var affectedRooms = {};
    thisVar.removedDevices.forEach(function (dev) {
      affectedRooms[dev.roomId] = true;
    });
    //plannerHistoryHelper.startPulseRooms(affectedRooms);
    $('#svgAndChat').addClass('pulsing');

    plannerHistoryHelper.chainPlaceDevices(thisVar.removedDevices, 0, function () {
      /* plannerHistoryHelper.placeEntities([], [], thisVar.affectedGroups, thisVar.removedMeasurements) */
      new EntityPlacerBuilder()
      .setGroups(thisVar.affectedGroups)
      .setMeasurements(thisVar.removedMeasurements)
      .setSerialConnections(thisVar.serialConnections)
      .run()
      .done(function () {
        //plannerHistoryHelper.stopPulseRooms(affectedRooms);
        $('#svgAndChat').removeClass('pulsing');
        callIfFn(callback, true);
      })
      .fail(function () {
        //plannerHistoryHelper.stopPulseRooms(affectedRooms);
        $('#svgAndChat').removeClass('pulsing');
        callIfFn(callback, false);
      });
    }, function () {
      //plannerHistoryHelper.stopPulseRooms(affectedRooms);
      $('#svgAndChat').removeClass('pulsing');
      callIfFn(callback, false);
    });
  }
  deviceIdChanged(from, to) {
    var thisVar = this;
    var dev = this.removedDevices.find(function (dev) { return thisVar.equalAsString(from, dev.deviceId); });
    if (dev) {
      dev.deviceId = to;
    }
    for (var i = 0; i < this.affectedGroups.length; i++) {
      var group = this.affectedGroups[i];
      for (var j = 0; j < group.deviceIds.length; j++) {
        if (this.equalAsString(group.deviceIds[j], from)) {
          group.deviceIds[j] = to;
        }
      }
    }
    plannerHistoryHelper.updateMeasurementDeviceIds(from, to, this.removedMeasurements);
  }
  roomIdChanged(from, to) {
    var thisVar = this;
    thisVar.removedDevices.forEach(function (dev) {
      if (thisVar.equalAsString(from, dev.roomId)) {
        dev.roomId = to;
      }
    });
  }
  serialIdChanged(from, to) {
    var thisVar = this;
    plannerHistoryHelper.updateMeasurementSerialIds(from, to, this.removedMeasurements);
    thisVar.removedDevices.forEach(function (dev) {
      if (thisVar.equalAsString(from, dev.targetSerialId)) {
        dev.targetSerialId = to;
      }
    });
    plannerHistoryHelper.updateSerialIdInConnections(from, to, this.serialConnections);
  }
  serialConnectionIdChanged(from, to) {
    plannerHistoryHelper.updateSerialConnectionId(from, to, this.serialConnections);
  }
  wallIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallIds(from, to, this.removedMeasurements);
  }
  wallModIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallModIds(from, to, this.removedMeasurements);
  }
  measurementIdChanged(from, to) {
    var thisVar = this;
    this.removedMeasurements.forEach(function (meas) {
      if (thisVar.equalAsString(meas.id, from)) {
        meas.id = to;
      }
    });
  }
}

export class CreateSerialAction extends PlannerAction {
  constructor(x, y, roomId, angle, products, serialId, height, direction) {
    super();
    this.actionName = ts("p_do_action_frame_new", "Placing frame");
    this.x = x;
    this.y = y;
    this.roomId = roomId;
    this.angle = angle;
    this.products = products;
    this.serialId = serialId;
    this.height = height;
    this.direction = direction;
  }
  execute(callback) {
    var thisVar = this;
    var preSerId = this.serialId;
    placeSerialDevices(this.x, this.y, this.roomId, this.products, this.angle, true, this.height, this.direction)
    .done(function (serial) {
      if (serial) {
        thisVar.serialId = serial.id;
        PlannerGlobals.plannerHistoryManager.serialIdChanged(preSerId, serial.id);
      }
      callIfFn(callback, true);
    })
    .fail(function () {
      callIfFn(callback, false);
    });
  }
  undo(callback) {
    removeSerialDevices(this.serialId)
    .done(function () {
      callIfFn(callback, true);
    })
    .fail(function () {
      callIfFn(callback, false);
    });
  }
  serialIdChanged(from, to) {
    if (this.serialId && this.equalAsString(this.serialId, from)) {
      this.serialId = to;
    }
  }
  roomIdChanged(from, to) {
    if (this.equalAsString(this.roomId, from)) {
      this.roomId = to;
    }
  }
}

export class DeleteSerialAction extends PlannerAction {
  /**
   *
   * @param {number} x
   * @param {number} y
   * @param {number} roomId
   * @param {number} angle
   * @param {*} products
   * @param {number} serialId
   * @param {RemovedDevParams[]} removedDevParamsArr
   * @param {MeasurementConnection[]} removedSerialMeasures
   * @param {SerialConnection?} serialConnection
   */
  constructor(x, y, roomId, angle, products, serialId, removedDevParamsArr, removedSerialMeasures, serialConnection, height, direction) {
    super();
    this.actionName = ts("p_do_action_frame_del", "Deleting frame");
    this.x = x;
    this.y = y;
    this.roomId = roomId;
    this.angle = angle;
    this.products = products;
    this.serialId = serialId;
    this.removedDevParams = deepCopy(removedDevParamsArr);
    this.removedSerialMeasures = deepCopy(removedSerialMeasures);
    this.serialConnection = serialConnection;
    this.height = height;
    this.direction = direction;

    this.removedDevParams.forEach((param, idx) => {
      if (!param.note) {
        this.products[idx] = Object.assign({}, this.products[idx]);
        this.products[idx].prevent_note = true;
      }
    });
  }
  execute(callback) {
    removeSerialDevices(this.serialId)
    .done(function () {
      recalcSwitchPNIDs();
      callIfFn(callback, true);
    })
    .fail(function () {
      callIfFn(callback, false);
    });
  }
  undo(callback) {
    var thisVar = this;
    var preSerId = this.serialId;
    var preDevIds = this.removedDevParams.map(function (params) { return params.device.deviceId; });

    placeSerialDevices(this.x, this.y, this.roomId, this.products, this.angle, true, this.height, this.direction)
    .done(function (serial) {
      if (serial) {
        thisVar.serialId = serial.id;
        PlannerGlobals.plannerHistoryManager.serialIdChanged(preSerId, serial.id);

        var postDevIds = getSerialById(serial.id).deviceIds;

        postDevIds.forEach(function (id, idx) {
          PlannerGlobals.plannerHistoryManager.deviceIdChanged(preDevIds[idx], id);
        });

        var devDefs = [];

        thisVar.removedDevParams.forEach(function (params) {
          var noteDef = $.Deferred();
          if (params.note) {
            sendDevNoteAuto(params.device.deviceId, params.note.text, params.note.color, function (res) {
              if (res) {
                noteDef.resolve();
              }
              else {
                noteDef.reject();
              }
            });
          }
          else {
            /* const dev = getDeviceById(params.device.deviceId);
            if (dev && dev.noteTxt) {
                deleteDevNote(dev, () => noteDef.resolve());
                dev.noteTxt = null;
                dev.hasNote = false;
                redrawDevice(dev.deviceId);
            }
            else {
                noteDef.resolve();
            } */
            noteDef.resolve();

          }

          devDefs.push(noteDef);
        });

        var serMeasDefs = [];
        if (thisVar.removedSerialMeasures) {
          thisVar.removedSerialMeasures.forEach(function (meas) {
            let measDef = $.Deferred();
            serMeasDefs.push(measDef);
            meas.sentToServerPromise = $.Deferred();
            meas.justAdded = true;
            meas.justDeleted = false;
            PlannerGlobals.measurements.push(meas);
            let oriId = meas.id;
            addMeasurementAjax(meas, function (meas) {
              PlannerGlobals.plannerHistoryManager.measurementIdChanged(oriId, meas.id);
              measDef.resolve();
            }, function () {
              measDef.reject();
            });

          });
        }

        var groupDef = $.Deferred();
        plannerHistoryHelper.placeDevsIntoAllGroups(thisVar.removedDevParams, 0, function (res) {
          if (res) { groupDef.resolve(); }
          else { groupDef.reject(); }
        });
        devDefs.push(groupDef);

        if (thisVar.serialConnection) {
          var serConnDef = $.Deferred();
          devDefs.push(serConnDef);
          plannerHistoryHelper.setOlderSerialAsTargetInConnection(thisVar.serialConnection);
          plannerHistoryHelper.applySerialConnections([thisVar.serialConnection])
          .then(() => serConnDef.resolve())
          .catch(() => serConnDef.reject());
        }

        $.when.apply($, devDefs.concat(serMeasDefs))
        .done(function () {
          recalcSwitchPNIDs();
          callIfFn(callback, true);
        })
        .fail(function () {
          callIfFn(callback, false);
        });
      }
      else {
        callIfFn(callback, false);
      }
    })
    .fail(function () {
      callIfFn(callback, false);
    });
  }
  serialIdChanged(from, to) {
    if (this.equalAsString(this.serialId, from)) {
      this.serialId = to;
    }
    this.removedDevParams.forEach(function (params) {
      plannerHistoryHelper.updateMeasurementSerialIds(from, to, params.removedMeasures);
    });
    plannerHistoryHelper.updateMeasurementSerialIds(from, to, this.removedSerialMeasures);
    if (this.serialConnection) {
      plannerHistoryHelper.updateSerialIdInConnections(from, to, [this.serialConnection]);
    }
  }
  serialConnectionIdChanged(from, to) {
    if (this.serialConnection) {
      plannerHistoryHelper.updateSerialConnectionId(from, to, [this.serialConnection]);
    }
  }
  deviceIdChanged(from, to) {
    var thisVar = this;
    this.removedDevParams.forEach(function (params) {
      if (thisVar.equalAsString(params.device.deviceId, from)) {
        params.device.deviceId = to;
      }
      if (params.groups) {
        params.groups.forEach(function (grp) {
          grp.deviceIds.forEach(function (dId, idx) {
            if (thisVar.equalAsString(dId, from)) {
              grp.deviceIds[idx] = to;
            }
          });
        });
      }
      plannerHistoryHelper.updateMeasurementDeviceIds(from, to, params.removedMeasures);
    });
    plannerHistoryHelper.updateMeasurementSerialIds(from, to, this.removedSerialMeasures);
  }
  wallModIdChanged(from, to) {
    this.removedDevParams.forEach(function (params) {
      plannerHistoryHelper.updateMeasurementWallModIds(from, to, params.removedMeasures);
    });
    plannerHistoryHelper.updateMeasurementWallModIds(from, to, this.removedSerialMeasures);
  }
  wallIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallIds(from, to, this.removedSerialMeasures);
  }
  roomIdChanged(from, to) {
    if (this.equalAsString(this.roomId, from)) {
      this.roomId = to;
    }
  }
  measurementIdChanged(from, to) {
    var thisVar = this;
    this.removedDevParams.forEach(function (params) {
      params.removedMeasures.forEach(function (meas) {
        if (thisVar.equalAsString(meas.id, from)) {
          meas.id = to;
        }
      });
    });
  }
}

export class ChangeDevicesAction extends PlannerAction {
  /**
   *
   * @param {(number|string)[]} deviceIds
   * @param {Group[]} groups
   * @param {number} originalProdId
   * @param {number} targetProdId
   * @param {boolean} isOriginalCustom
   * @param {boolean} isTargetCustom
   * @param {Serial} serConnsOfDevs
   * @param {Object.<number, {id: number, height: number, direction: 'horizontal' | 'vertical', x, y, angle}>} deviceIdToSerialParams
   */
  constructor(deviceIds, groups, originalProdId, targetProdId, isOriginalCustom, isTargetCustom, disallowGrouping, serConnsOfDevs, deviceIdToSerialParams) {
    super();
    this.deviceIds = deviceIds;
    this.groups = groups;
    this.originalProdId = originalProdId;
    this.targetProdId = targetProdId;
    this.isOriginalCustom = isOriginalCustom;
    this.isTargetCustom = isTargetCustom;
    this.disallowGrouping = disallowGrouping;
    this.serConnsOfDevs = serConnsOfDevs;
    this.deviceIdToSerialParams = deviceIdToSerialParams;
    this.actionName = ts("p_do_action_change_dev", "Changing Device");
  }

  undo(callback) {
    var thisVar = this;
    $('#svgAndChat').addClass('pulsing');
    var changeParams = this.deviceIds.map(function (devId) {
      return {
        srcDeviceId: devId,
        targetProductId: thisVar.originalProdId,
        targetIdIsCustom: thisVar.isOriginalCustom
      }
    });
    chainChangeDevices(changeParams, 0, function (res) {
      new EntityPlacerBuilder()
      .setGroups(thisVar.groups)
      .setSerialConnections(thisVar.serConnsOfDevs)
      .run()
      .then(() => {
        $('#svgAndChat').removeClass('pulsing');
        redrawDevices();
        callIfFn(callback, true);
      })
      .catch(() => {
        $('#svgAndChat').removeClass('pulsing');
        redrawDevices();
        callIfFn(callback, false);
      });
    }, undefined, undefined, this.deviceIdToSerialParams);
  }

  execute(callback) {
    $('#svgAndChat').addClass('pulsing');
    var thisVar = this;
    var changeParams = this.deviceIds.map(function (devId) {
      const device = getDeviceById(devId);
      return {
        srcDeviceId: devId,
        targetProductId: thisVar.targetProdId,
        targetIdIsCustom: thisVar.isTargetCustom,
        forcedPosition: isDevMergedWithSerials(device.product_name_id) ?
            'auto' : uDev.getTopLeftOfDevice_NoDOM(device.deviceId)
      }
    });

    const liteSerialParams = {};
    for (let key in this.deviceIdToSerialParams) {
      liteSerialParams[key] = { id: this.deviceIdToSerialParams[key].id };
    }

    chainChangeDevices(changeParams, 0, function (res) {
      $('#svgAndChat').removeClass('pulsing');
      redrawDevices();
      callIfFn(callback, true);
    }, undefined, this.disallowGrouping, liteSerialParams);
  }

  deviceIdChanged(from, to) {
    var thisVar = this;
    for (var i = 0; i < this.deviceIds.length; i++) {
      if (this.equalAsString(from, this.deviceIds[i])) {
        this.deviceIds[i] = to;
      }
    }
    this.groups.forEach(function (group) {
      group.deviceIds.forEach(function (devId, idx) {
        if (thisVar.equalAsString(devId, from)) {
          group.deviceIds[idx] = to;
        }
      });
    });
    for (let key in this.deviceIdToSerialParams) {
      if (this.equalAsString(key, from)) {
        this.deviceIdToSerialParams[to] = this.deviceIdToSerialParams[from];
        delete this.deviceIdToSerialParams[from];
      }
    }
  }
  serialIdChanged(from, to) {
    for (let key in this.deviceIdToSerialParams) {
      if (this.equalAsString(this.deviceIdToSerialParams[key].id, from)) {
        this.deviceIdToSerialParams[key].id = to;
      }
    }
    plannerHistoryHelper.updateSerialIdInConnections(from, to, this.serConnsOfDevs);
  }
  serialConnectionIdChanged(from, to) {
    plannerHistoryHelper.updateSerialConnectionId(from, to, this.serConnsOfDevs);
  }
}

export class PopOutFromSerialAction extends PlannerAction {
  constructor(devId, oldSerId, newSerId) {
    super();
    this.actionName = ts("p_do_action_popout", "Removing device from frame");
    this.oldSerId = oldSerId;
    this.newSerId = newSerId;
    this.devId = devId;
  }

  execute(callback) {
    detachFromSerial(this.devId)
    .then(() => {
      // this.devId is changed by detachFromSerial method
      const newSer = getSerialOfDeviceId(this.devId);
      if (newSer) {
        PlannerGlobals.plannerHistoryManager.serialIdChanged(this.newSerId, newSer.id);
      }
      callIfFn(callback, true);
    })
    .catch(() => {
      callIfFn(callback, false);
    });
  }

  undo(callback) {
    const devSer = getSerialOfDeviceId(this.devId);
    if (devSer) {
      mergeSerials(devSer.id, this.oldSerId)
      .then(() => {
        callIfFn(callback, true);
      })
      .catch(() => {
        callIfFn(callback, false);
      });
    }
    else {
      callIfFn(callback, false);
    }
  }

  deviceIdChanged(from, to) {
    if (this.equalAsString(from, this.devId)) {
      this.devId = to;
    }
  }

  serialIdChanged(from, to) {
    if (this.equalAsString(from, this.oldSerId)) {
      this.oldSerId = to;
    }
    if (this.equalAsString(from, this.newSerId)) {
      this.newSerId = to;
    }
  }
}

export class MergeSerialsAction extends PlannerAction {
  /**
   *
   * @param {number} srcSerId
   * @param {number} tarSerId
   * @param {number[]} srcDeviceIds
   */
  constructor(srcSerId, tarSerId, srcDeviceIds, oldHeight, oldDir) {
    super();
    this.actionName = ts("p_do_action_mergeframes", "Merging frames");
    this.srcSerId = srcSerId;
    this.tarSerId = tarSerId;
    this.srcDeviceIds = srcDeviceIds;
    this.oldHeight = oldHeight;
    this.oldDir = oldDir;
  }

  execute(callback) {
    mergeSerials(this.srcSerId, this.tarSerId)
    .then(() => {
      callIfFn(callback, true);
    })
    .catch(() => {
      callIfFn(callback, false);
    });
  }

  undo(callback) {
    let targetSerial = null;

    const placeCurrDevId = (deviceId) => {
      return detachFromSerial(deviceId, targetSerial).then((newDeviceId) => {
        if (!targetSerial) {
          const ser = getSerialOfDeviceId(newDeviceId);
          targetSerial = ser;
          targetSerial.height = this.oldHeight;
          targetSerial.direction = this.oldDir;
          redrawDevice(newDeviceId);
        }
      });
    }

    this.srcDeviceIds
    .sort((a, b) => b - a)
    .reduce((p, c) => {
      return p.finally(() => placeCurrDevId(c));
    }, Promise.resolve())
    .then(() => {
      if (targetSerial) {
        PlannerGlobals.plannerHistoryManager.serialIdChanged(this.srcSerId, targetSerial.id);
        ajaxSetSerialProps(targetSerial)
        .then(() => callIfFn(callback, true))
        .catch(() => callIfFn(callback, false));
      }
      else {
        callIfFn(callback, false);
      }
    })
    .catch((a, b, c) => {
      console.log(a, b, c);
      callIfFn(callback, false);
    });
  }

  serialIdChanged(from, to) {
    if (this.equalAsString(from, this.srcSerId)) {
      this.srcSerId = to;
    }
    if (this.equalAsString(from, this.tarSerId)) {
      this.tarSerId = to;
    }
  }

  deviceIdChanged(from, to) {
    for (let i = 0; i < this.srcDeviceIds.length; i++) {
      if (this.equalAsString(from, this.srcDeviceIds[i])) {
        this.srcDeviceIds[i] = to;
      }
    }
  }
}

/* DEVICE END */
